import { useState } from "react";
import { supabase } from "../supabaseClient";
import { T } from "../lib/i18n";

// Bara LU-inloggning (Azure AD med domain_hint=lu.se) visas. Google,
// e-post/lösenord, "skapa konto" och "glömt lösenord" är borttagna ur vyn på
// Johans begäran 2026-09-02 — verktyget är för LU-personal. Auth-backend är
// orörd: befintliga sessioner, inbjudningslänkar och lösenordsåterställning
// via länk fungerar fortfarande; det som saknas är formulären för dem.
function LoginScreen({ lang, G, css }) {
  const t = T[lang];
  const [luLogoError, setLuLogoError] = useState(false);

  async function signInLU() {
    await supabase.auth.signInWithOAuth({
      provider: "azure",
      options: {
        redirectTo: window.location.origin,
        queryParams: { domain_hint: "lu.se" },
      },
    });
  }

  return (
    <div style={{ minHeight: "100vh", background: G.bg, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'DM Sans',sans-serif" }}>
      <div style={{ ...css.card, maxWidth: 400 }}>
        <h2 style={{ ...css.heading, fontSize: 26, marginBottom: 6 }}>{t.signIn}</h2>
        <p style={{ color: G.muted, fontSize: 14, marginBottom: 28 }}>{t.signInSub}</p>

        {/* Lund University (Azure AD via domain_hint=lu.se) */}
        <button onClick={signInLU} style={{
          width: "100%",
          background: G.surface,
          color: G.text,
          border: `1px solid ${G.border}`,
          borderRadius: 12,
          fontSize: 15, fontWeight: 600,
          padding: "12px 20px",
          cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          gap: 12,
          transition: "border-color 0.15s, background 0.15s",
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = G.gold; e.currentTarget.style.background = G.surface2; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = G.border; e.currentTarget.style.background = G.surface; }}
        >
          {!luLogoError && (
            <img
              src="/LU-sigill2.png"
              alt=""
              aria-hidden="true"
              onError={() => setLuLogoError(true)}
              style={{ width: 32, height: 32, objectFit: "contain", flexShrink: 0 }}
            />
          )}
          {t.signInWithLU}
        </button>
      </div>
    </div>
  );
}

export { LoginScreen };
